module.exports = __webpack_public_path__ + "static/media/Credits.0a0bca6d.svg";